import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { playWin } from '../soundManager';

// Default amount of confetti pieces (can be overridden via `count` prop)
const DEFAULT_PIECE_COUNT = 160;

export function Confetti({
  active,
  style,
  count = DEFAULT_PIECE_COUNT,
  soundSrc = '/sfx/win.mp3',
  volume = 0.12,
}) {
  const [pieces, setPieces] = useState([]);
  const playedRef = useRef(false);

  useEffect(() => {
    if (!active) return;
    const newPieces = Array.from({ length: Math.max(1, Math.min(600, count)) }).map(() => ({
      left: Math.random() * 100,
      bg: `hsl(${Math.random() * 360},100%,50%)`,
      delay: Math.random() * 0.5,
      duration: 2 + Math.random() * 3,
    }));
    setPieces(newPieces);
  }, [active, count]);

  // Play low-latency sound ASAP when becoming active
  useEffect(() => {
    if (!active) { playedRef.current = false; return; }
    if (playedRef.current) return;
    playedRef.current = true;
    // Use WebAudio-driven manager first
    playWin({ url: soundSrc, volume });
  }, [active, volume, soundSrc]);

  if (!active) return null;

  // Render at the document level to avoid being clipped by modal overflow/transform
  return createPortal(
    <div className="confetti-container" style={style}>
      {pieces.map((p, i) => (
        <div
          key={i}
          className="confetti-piece"
          style={{
            left: `${p.left}%`,
            backgroundColor: p.bg,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
          }}
        />
      ))}
    </div>,
    document.body
  );
}
